// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyBOx63MZhKDPFOS3-lGOjZSoOrFCdtr0Xs",
  authDomain: "ciet-lms.firebaseapp.com",
  projectId: "ciet-lms",
  storageBucket: "ciet-lms.firebasestorage.app",
  messagingSenderId: "28530245532",
  appId: "1:28530245532:web:c32d3026cd73fb18651259",
  measurementId: "G-L0B7X6X5M5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);